export default __webpack_public_path__ + "static/media/profile.358d25c2.jpeg";